import { render } from "./LifeCriticalInsuranceForm.vue?vue&type=template&id=493f5343&scoped=true"
import script from "./LifeCriticalInsuranceForm.vue?vue&type=script&lang=js"
export * from "./LifeCriticalInsuranceForm.vue?vue&type=script&lang=js"

import "./LifeCriticalInsuranceForm.vue?vue&type=style&index=0&id=493f5343&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-493f5343"]])

export default __exports__